import React from 'react'
import { Row, Container } from 'react-bootstrap';
import './casestudybody20.css';

import clientimg from '../images/case-study-client20.webp'
import outcome from '../images/outcome20.webp'

import sm1 from '../images/cs20so1.webp'
import sm2 from '../images/cs20so2.webp'
import sm3 from '../images/cs20so3.webp'
import sm4 from '../images/cs20so4.webp'
import sm5 from '../images/cs20so5.webp'


const Casestudybody20 = () => {

    return (
        <>
        <section className='casestudybody20-section' >
          <Container>
            <Row className='w-100 py-md-5 py-4 clintrow'>
                <div className='col-md-4 relative order-1'>
                  <div className='left-box'>
                    <div className='content-box'>
                      <h2>About</h2>
                      {/* <div className="h1"><span className='h1 animate-underline' style={{ paddingBottom: "40px" }}>The Client</span></div> */}
                      <div className="h1">The Client</div>
                      <p className='anima '><span className='only-anima-underline' > **** </span></p>
                      <p>The client is a U.S.based private equity firm specializing in small-ticket investments ranging from $10 to $20 million. They primarily invest in companies with strong growth potential and competitive market positioning.</p>
                    </div>
                  </div>
                           
                </div>
                <div className='col-md-8 right-box'>
                    <img src={clientimg} alt="" />
                </div>
            </Row>
       
            <Row className='mt-md-5'>
              <div className='col-md-12'>
                <div className='content-box'>
                  <h2>Situation</h2>
                  {/* <div className="h1"><span className='h1 animate-underline' style={{ paddingBottom: "40px" }}>The Client</span></div> */}
                  <div className="h1">Overview</div>
                  <p className='anima '><span className='only-anima-underline' > **** </span></p>
                  <p>The client was assessing the potential acquisition of an affordable luxury apparel brand specializing in men's and women's fashion. To make an informed decision, they required due diligence to evaluate the company's financial health, identify potential risks, and evaluate the strategic fit of the acquisition within their portfolio.</p>

                  {/* <ul className='overview-list'>
                    <li>Develop and present a compelling business case to the Investment Committee, underlining the feasibility and potential profitability of the venture</li>
                    <li>Execute an industry analysis, ensuring a well-informed Go-To-Market (GTM) strategy that aligned with the dynamics and opportunities within the coffee industry</li>
                  </ul> */}

                </div>
                
              </div>
            </Row>
          </Container>
        </section>
    
        <section className='casestudybody20-section bg-gredient-dark'>
          <Container>
            <Row>
              <div className='col-md-12'>
                  <div className='content-box'>
                    <h2>Approach &</h2>
                    {/* <div className="h1"><span className='h1 animate-underline' style={{ paddingBottom: "40px" }}>The Client</span></div> */}
                    <div className="h1">Methodology</div>
                    <p className='anima '><span className='only-anima-underline' > **** </span></p>
                    
                    {/* <div className='method-stage'> <span>PHASE 01 </span>Framework Development</div> */}
                    <p>Our analysis spanned from data collection to financial statement analysis, examining the target company's financial health and stability to determine its suitability for acquisition.</p>

                    <div className='list-text last my-3'>
                        <div className='icon'>
                        <svg width="78" height="55" viewBox="0 0 78 55" fill="none" xmlns="http://www.w3.org/2000/svg">
                         <rect x="0.5" y="0.5" width="77" height="54" rx="27" fill="#03A393" stroke="#03A393"/>
                         <path d="M24.2002 27.585C24.2002 30.0264 24.4004 31.8965 24.8008 33.1953C25.2012 34.4844 26.0215 35.1289 27.2617 35.1289C28.502 35.1289 29.3125 34.4844 29.6934 33.1953C30.084 31.8965 30.2793 30.0264 30.2793 27.585C30.2793 25.0264 30.084 23.1318 29.6934 21.9014C29.3125 20.6709 28.502 20.0557 27.2617 20.0557C26.0215 20.0557 25.2012 20.6709 24.8008 21.9014C24.4004 23.1318 24.2002 25.0264 24.2002 27.585ZM27.2617 16.6133C29.9668 16.6133 31.8613 17.5654 32.9453 19.4697C34.0391 21.374 34.5859 24.0791 34.5859 27.585C34.5859 31.0908 34.0391 33.791 32.9453 35.6855C31.8613 37.5801 29.9668 38.5273 27.2617 38.5273C24.5566 38.5273 22.6572 37.5801 21.5635 35.6855C20.4795 33.791 19.9375 31.0908 19.9375 27.585C19.9375 24.0791 20.4795 21.374 21.5635 19.4697C22.6572 17.5654 24.5566 16.6133 27.2617 16.6133ZM37.7793 23.3516V20.5098C39.0977 20.4512 40.0205 20.3633 40.5479 20.2461C41.3877 20.0605 42.0713 19.6895 42.5986 19.1328C42.96 18.752 43.2334 18.2441 43.4189 17.6094C43.5264 17.2285 43.5801 16.9453 43.5801 16.7598H47.0518V38H42.7744V23.3516H37.7793Z" fill="#02080C"/>
                        </svg>

                        </div>
                        <div className='text'>
                          <h4>Data Room Creation and Maintenance</h4>
                          <p>We created a centralized virtual data room to consolidate financial and operational data from various sources and timeframes. The collected information was organized and analyzed to provide an overview of the target company.</p>
                        </div>
                      </div>

                      <div className='list-text last my-3'>
                        <div className='icon'>
                        <svg width="78" height="55" viewBox="0 0 78 55" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <rect x="0.5" y="0.5" width="77" height="54" rx="27" fill="#03A393" stroke="#03A393"/>
                          <path d="M24.2002 27.585C24.2002 30.0264 24.4004 31.8965 24.8008 33.1953C25.2012 34.4844 26.0215 35.1289 27.2617 35.1289C28.502 35.1289 29.3125 34.4844 29.6934 33.1953C30.084 31.8965 30.2793 30.0264 30.2793 27.585C30.2793 25.0264 30.084 23.1318 29.6934 21.9014C29.3125 20.6709 28.502 20.0557 27.2617 20.0557C26.0215 20.0557 25.2012 20.6709 24.8008 21.9014C24.4004 23.1318 24.2002 25.0264 24.2002 27.585ZM27.2617 16.6133C29.9668 16.6133 31.8613 17.5654 32.9453 19.4697C34.0391 21.374 34.5859 24.0791 34.5859 27.585C34.5859 31.0908 34.0391 33.791 32.9453 35.6855C31.8613 37.5801 29.9668 38.5273 27.2617 38.5273C24.5566 38.5273 22.6572 37.5801 21.5635 35.6855C20.4795 33.791 19.9375 31.0908 19.9375 27.585C19.9375 24.0791 20.4795 21.374 21.5635 19.4697C22.6572 17.5654 24.5566 16.6133 27.2617 16.6133ZM36.6367 38C36.6758 36.4766 37.0029 35.085 37.6182 33.8252C38.2139 32.4092 39.6201 30.9102 41.8369 29.3281C43.7607 27.9512 45.0059 26.9648 45.5723 26.3691C46.4414 25.4414 46.876 24.4258 46.876 23.3223C46.876 22.4238 46.627 21.6768 46.1289 21.0811C45.6309 20.4854 44.918 20.1875 43.9902 20.1875C42.7207 20.1875 41.8564 20.6611 41.3975 21.6084C41.1338 22.1553 40.9775 23.0244 40.9287 24.2158H36.8711C36.9395 22.4092 37.2666 20.9492 37.8525 19.8359C38.9658 17.7168 40.9434 16.6572 43.7852 16.6572C46.0312 16.6572 47.8184 17.2822 49.1465 18.5322C50.4746 19.7725 51.1387 21.418 51.1387 23.4688C51.1387 25.041 50.6699 26.4375 49.7324 27.6582C49.1172 28.4688 48.1064 29.3721 46.7002 30.3682L45.0303 31.5547C43.9854 32.2969 43.2676 32.834 42.877 33.166C42.4961 33.498 42.1738 33.8838 41.9102 34.3232H51.1826V38H36.6367Z" fill="#02080C"/>
                        </svg>


                        </div>
                        <div className='text'>
                          <h4>Data Analysis</h4>
                          <p>The next step was to conduct an in-depth analysis of the target company to assess the company's profitability and growth potential. For this objective, we analyzed the following metrics:</p>
                          <ul className='body' style={{ listStyle: 'none', paddingLeft: '0px' }}>
                            <li>a. Historical statement analysis</li>
                            <li>b. Revenue trends and drivers</li>
                            <li>c. Expense patterns</li>
                            <li>d. Customer concentration and retention analysis</li>
                            <li>e. Seasonality patterns in different business segments</li>
                            <li>f. Cash flow and AR, AP, and inventory analysis</li>
                          </ul>
                        </div>
                      </div>

                      <div className='list-text last my-3'>
                        <div className='icon'>
                        <svg width="78" height="55" viewBox="0 0 78 55" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <rect x="0.5" y="0.5" width="77" height="54" rx="27" fill="#03A393" stroke="#03A393"/>
                          <path d="M24.2002 27.585C24.2002 30.0264 24.4004 31.8965 24.8008 33.1953C25.2012 34.4844 26.0215 35.1289 27.2617 35.1289C28.502 35.1289 29.3125 34.4844 29.6934 33.1953C30.084 31.8965 30.2793 30.0264 30.2793 27.585C30.2793 25.0264 30.084 23.1318 29.6934 21.9014C29.3125 20.6709 28.502 20.0557 27.2617 20.0557C26.0215 20.0557 25.2012 20.6709 24.8008 21.9014C24.4004 23.1318 24.2002 25.0264 24.2002 27.585ZM27.2617 16.6133C29.9668 16.6133 31.8613 17.5654 32.9453 19.4697C34.0391 21.374 34.5859 24.0791 34.5859 27.585C34.5859 31.0908 34.0391 33.791 32.9453 35.6855C31.8613 37.5801 29.9668 38.5273 27.2617 38.5273C24.5566 38.5273 22.6572 37.5801 21.5635 35.6855C20.4795 33.791 19.9375 31.0908 19.9375 27.585C19.9375 24.0791 20.4795 21.374 21.5635 19.4697C22.6572 17.5654 24.5566 16.6133 27.2617 16.6133ZM40.5918 31.4814C40.5918 32.3311 40.7285 33.0342 41.002 33.5908C41.5098 34.6162 42.4326 35.1289 43.7705 35.1289C44.5908 35.1289 45.3037 34.8506 45.9092 34.2939C46.5244 33.7275 46.832 32.917 46.832 31.8623C46.832 30.4658 46.2656 29.5332 45.1328 29.0645C44.4883 28.8008 43.4727 28.6689 42.0859 28.6689V25.6807C43.4434 25.6611 44.3906 25.5293 44.9277 25.2852C45.8555 24.875 46.3193 24.0449 46.3193 22.7949C46.3193 21.9844 46.0801 21.3252 45.6016 20.8174C45.1328 20.3096 44.4688 20.0557 43.6094 20.0557C42.623 20.0557 41.8955 20.3682 41.4268 20.9932C40.9678 21.6182 40.748 22.4531 40.7676 23.498H36.8711C36.9102 22.4434 37.0908 21.4424 37.4131 20.4951C37.7549 19.665 38.292 18.8984 39.0244 18.1953C39.5713 17.6973 40.2207 17.3164 40.9727 17.0527C41.7246 16.7891 42.6475 16.6572 43.7412 16.6572C45.7725 16.6572 47.4082 17.1846 48.6484 18.2393C49.8984 19.2842 50.5234 20.6904 50.5234 22.458C50.5234 23.708 50.1523 24.7627 49.4102 25.6221C48.9414 26.1592 48.4531 26.5254 47.9453 26.7207C48.3262 26.7207 48.873 27.0479 49.5859 27.7021C50.6504 28.6885 51.1826 30.0361 51.1826 31.7451C51.1826 33.542 50.5576 35.124 49.3076 36.4912C48.0674 37.8486 46.2266 38.5273 43.7852 38.5273C40.7773 38.5273 38.6875 37.5459 37.5156 35.583C36.9004 34.5381 36.5586 33.1709 36.4902 31.4814H40.5918Z" fill="#02080C"/>
                        </svg>


                        </div>
                        <div className='text'>
                          <h4>Due Diligence</h4>
                            <ul className='body' style={{ listStyle: 'none', paddingLeft: '0px' }}>
                                <li><b>a. Sustainability check: </b>
                                    <p>Identified potential sustainability risks, including excessive revenue concentration, customer churn, a prolonged cash conversion cycle, rising employee benefit costs, and contractual obligations with major customers.</p>
                                </li>
                                <li><b>b. Quality of earnings analysis: </b>
                                    <p>Highlighted underlying issues such as declining gross margins due to increased costs and licensing fees and overreliance on a single customer for revenue and receivables.</p>
                                </li>
                                <li><b>c. Clean income and one-time income analysis: </b>
                                    <p>Identified non-recurring items, including goodwill impairment adjustment, significant asset/liability adjustments, and negative depreciation adjustments.</p>
                                </li>
                            </ul>
                        </div>
                      </div>

                   

                    
                      <h3 className='mt-5'>Sample Output</h3>
                      
                      <div className='sample-output mt-3'>
                        <img src={sm1} alt=''/>
                        <img src={sm2} alt=''/>
                        <img src={sm3} alt=''/>
                        <img src={sm4} alt=''/>
                        <img src={sm5} alt=''/>
                      </div>
                  </div>
                  
                </div>
            </Row>
          </Container>
        </section>
    
        <section className='casestudybody20-section outcome'  >
          <Container>
            <Row className='w-100 pb-5 clintrow '>
                <div className='col-md-4 relative order-1'>
                  <div className='left-box'>
                    <div className='content-box'>
                      <div className="h1">Outcome</div>
                      <p className='anima '><span className='only-anima-underline' > **** </span></p>
                      <p>The financial due diligence enabled the client to make an informed decision, resulting in the successful acquisition of the target company, guided by our comprehensive assessment report.</p>  
                    
                    </div>
                  </div>
                           
                </div>
                <div className='col-md-8 right-box'>
                    <img src={outcome} alt="" />
                </div>
            </Row>
       
          </Container>
        </section>
    
        </>  
      )
}

export default Casestudybody20
